import {datasourcestore, DefaultEntity, RestDataSource} from "@intermesh/goui";
import {ServerApi} from "../util/ServerApi.js";

export interface LanguageEntity extends DefaultEntity {
	id: string,
	key: string,
	deleted: boolean,
	createdAt: string,
	modifiedAt: string,
	createdBy: string,
	generalTerms: string,
	pleaseEnterCredentials: string,
	credentialCheck: string,
	active: boolean
}

export const languageDS = new RestDataSource<LanguageEntity>(ServerApi.url("elearning/frontend/languages", {}, true), "languages");

export const languagesStore = datasourcestore({
	dataSource: languageDS
});